import { useState } from 'react';
import { Box, Button, CloseButton, Flex, Icon, Link, Text } from '@customerio/pluma-components/react';
import { generatePath } from '@/services/router/generate-path';
import { useAnalytics } from '@/services/analytics';
import { useWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';
import aiBannerBg from '@/assets/images/abyss.webp';
import * as styles from './welcome-banner.css';

const DISMISSED_KEY = 'home:welcome-banner-dismissed';

export function WelcomeBanner() {
  const workspaceId = useWorkspaceIdFromCurrentUrl() ?? 0;
  const { track } = useAnalytics();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISSED_KEY) === 'true');

  if (dismissed) {
    return null;
  }

  return (
    <Box w="full" position="relative" className={styles.card}>
      <div className={styles.cardBackground} style={{ backgroundImage: `url(${aiBannerBg})` }} />
      <CloseButton
        onClick={() => {
          localStorage.setItem(DISMISSED_KEY, 'true');
          setDismissed(true);
          track('home', 'welcomeBannerDismissed', {});
        }}
        className={styles.closeButton}
      />
      <Flex direction="column" gap="100" position="relative" zIndex="control-group-hover">
        <div className={styles.title}>More reach, more intelligence, more clarity—all from here</div>
        <Text size="s" className={styles.bodyText}>
          Pick up right where you left off with your recent work, or start something from scratch. Ask the Agent to
          build segments, campaigns, and email designs, prompt it for analysis, or simply ask what&apos;s going on in
          your workspace. This isn&apos;t the only thing we just launched.{'\u00A0'}
          <Link
            href="https://customer.io/learn/announcements/biggest-ai-marketing-release"
            isExternal={true}
            className={styles.link}
          >
            Read the announcement
          </Link>
        </Text>
        <Box pt="100">
          <Button
            variant="secondary"
            size="sm"
            href={generatePath('/workspaces/:workspaceId/agent', { workspaceId })}
            onClick={() => track('home', 'welcomeBannerCtaClicked', {})}
          >
            <Icon name="sparkle" size="sm" sizeVersion="v2" />
            Chat with the Agent
          </Button>
        </Box>
      </Flex>
    </Box>
  );
}
